var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProposalVariants',{attrs:{"proposal":_vm.proposal,"connection":_vm.connection},on:{"proposal:updated":_vm.reloadProposal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }